import { useEffect, useState } from "react";
import { useAuthState } from "../../context/AuthContext";
import { Button, Card, CardBody, Col, Container, Row, Spinner } from "react-bootstrap";
import Steper from "../../components/shared/Steper";
import QrOrManuel from "../../components/form_masks/anlage/new/QrOrManuel";
import AddressMask from "../../components/form_masks/anlage/new/AddressMask.jsx";
import Validator from "../../services/Validator";
import AnlageDataMask from "../../components/form_masks/anlage/new/AnlageDataMask";
import RegisterMask from "../../components/form_masks/anlage/new/RegisterMask";
import SummaryMask from "../../components/form_masks/anlage/new/SummaryMask";
import PrivateApi from "../../services/PrivateApiService";
import DoneMask from "../../components/form_masks/share/DoneMask";
import ErrorMask from "../../components/form_masks/share/ErrorMask";
import ScanQrMask from "../../components/form_masks/anlage/new/ScanQrMask";

const AnlageAnmeldePage = () => {

    const API = new PrivateApi();
    const [apiError, setApiError] = useState("");
    const { user } = useAuthState();
    const VALIDATOR = new Validator();
    const [isLoading, setIsLoading] = useState(false);
    const [places, setPlaces] = useState([]);
    const [step, setStep] = useState("choice");
    const [stepIndicator, setStepIndicator] = useState([
        {id: "step1", key:"choice", title:"Auswahl", number: 1},
        {id: "step2", key:"address", title:"Adresse", number: 2},
        {id: "step3", key:"anlageData", title:"Anlagendaten", number: 3},
        {id: "step4", key:"register", title:"Anmeldedaten", number: 4},
        {id: "step5", key:"summary", title:"Ihre Zusammenfassung", number: 5},
    ]);
    const [data, setData] = useState({
        choice: "",
        qr_code: "",

        x_anlagenverwendung: "Wohnung",
        x_anlagenverwendung_detail: "",
        country_id: "12",
        state_id: "",
        zip: "",
        city: "",
        street: "",
        houseNr: "",
        stiege: "",
        top: "",

        energyForm: "",
        x_is_smartmeter_01: false,
        x_is_smartmeter_02: false,
        secondZaehler: false,
        zaehlerLocation: "",
        x_zaehlernummer_01: "",
        x_zaehlernummer_02: "",
        x_zaehlpunktnummer_01: "",
        x_zaehlpunktnummer_02: "",
        zaehlerstand1: "",
        zaehlerstand2: "",

        register: true,
        registerDate: "",

        anlagen: [],
    });
    const [formError, setFormError] = useState({});


    useEffect(() => {
        const qrSteps = [
            {id: "step1", key:"choice", title:"Auswahl", number: 1},
            {id: "step2", key:"scannQr", title:"QR Scannen", number: 2},
            {id: "step3", key:"selectAnlage", title:"Anlagen auswählen", number: 3},
            {id: "step4", key:"register", title:"Anmeldedaten", number: 4},
            {id: "step5", key:"summary", title:"Ihre Zusammenfassung", number: 5},
        ];
        const manuelSteps = [
            {id: "step1", key:"choice", title:"Auswahl", number: 1},
            {id: "step2", key:"address", title:"Adresse", number: 2},
            {id: "step3", key:"anlageData", title:"Anlagendaten", number: 3},
            {id: "step4", key:"register", title:"Anmeldedaten", number: 4},
            {id: "step5", key:"summary", title:"Ihre Zusammenfassung", number: 5},
        ];

        if (data.choice === "qr") {
            setStepIndicator(qrSteps);
        } else {
            setStepIndicator(manuelSteps);
        }
    }, [data.choice]);


    const backHandler = () => {
        const index = stepIndicator.findIndex((i) => i.key === step);
        if (index > 0) {
            setStep(stepIndicator[index -1].key);
        }
    }

    const nextHandler = () => {
        var tmpError = {}

        // checks
        if (step === "choice") {
            if (data.choice === undefined || data.choice === "") tmpError.choice = true;
        } 
        if (step === "address") {
            if (data.x_anlagenverwendung === undefined || data.x_anlagenverwendung === "") tmpError.x_anlagenverwendung = true;
            if (data.country_id === "") tmpError.country_id = true;
            if (data.country_id === "12" && data.state_id === "") tmpError.state_id = true;
            if (!VALIDATOR.isValidZip(data.country_id, data.state_id, data.zip)) tmpError.zip = true;
            if (data.city === "" || data.city.length < 3) tmpError.city = true;
            if (!VALIDATOR.StringLength(3, 80, data.street)) tmpError.street = true;
            if (!data.houseNr || data.houseNr === "") tmpError.houseNr = true;
            if (data.x_anlagenverwendung === "Wohnung" && data.top === "") tmpError.top = true;
        }
        if (step === "anlageData") {
            if (!VALIDATOR.isValidEnergyForm(data.energyForm)) tmpError.energyForm = true;
            if (data.x_zaehlernummer_01 === undefined || data.x_zaehlernummer_01.length < 6) tmpError.x_zaehlernummer_01 = true;
            if (
                data.x_zaehlernummer_02 && 
                data.secondZaehler === true && 
                (!data.x_zaehlernummer_02 || data.x_zaehlernummer_02.length < 6)
            ) tmpError.x_zaehlernummer_02 = true;
            if (
                data.x_zaehlpunktnummer_01 &&
                data.x_zaehlpunktnummer_01 !== "" && 
                !VALIDATOR.isFormatedZaehlpunknummerValid(data.x_zaehlpunktnummer_01)) tmpError.x_zaehlpunktnummer_01 = true;
            if (
                data.secondZaehler && data.secondZaehler === true &&
                data.x_zaehlpunktnummer_02 &&
                data.x_zaehlpunktnummer_02 !== "" && !VALIDATOR.isFormatedZaehlpunknummerValid(data.x_zaehlpunktnummer_02)
            ) tmpError.x_zaehlpunktnummer_02 = true;
        }
        if (step === "register") {
            if (!data.registerDate || !VALIDATOR.dateValid(data.registerDate)) tmpError.registerDate = true;
            if (data.x_is_smartmeter_01 === false && !VALIDATOR.IsZaehlerstand(data.zaehlerstand1)) tmpError.zaehlerstand1 = true;
            if (
                data.x_is_smartmeter_01 === false &&
                data.secondZaehler === true &&
                !VALIDATOR.IsZaehlerstand(data.zaehlerstand2)
            ) tmpError.zaehlerstand2 = true;
        }

        if (step === "summary") return sendData();

        if (Object.keys(tmpError).length > 0) {
            return setFormError(tmpError);
        }
        const index = stepIndicator.findIndex((i) => i.key === step);
        setStep(stepIndicator[index + 1].key);
    }

    const sendData = () => {
        setIsLoading(true);
        data.user = user;
        API.private_Anlagen_new(data)
            .then(() => {
                setStep("done");
            })
            .catch((err) => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                setStep("error");
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const startOver = (e) => {
        e.preventDefault();
        setData({
            choice: "",
            qr_code: "",

            x_anlagenverwendung: "Wohnung",
            x_anlagenverwendung_detail: "",
            country_id: "12",
            state_id: "",
            zip: "",
            city: "",
            street: "",
            houseNr: "",
            stiege: "",
            top: "",

            energyForm: "",
            x_is_smartmeter_01: false,
            x_is_smartmeter_02: false,
            secondZaehler: false,
            zaehlerLocation: "",
            x_zaehlernummer_01: "",
            x_zaehlernummer_02: "",
            x_zaehlpunktnummer_01: "",
            x_zaehlpunktnummer_02: "",
            zaehlerstand1: "",
            zaehlerstand2: "",

            register: true,
            registerDate: "",

            anlagen: [],
        });
        setStep("choice")
    } 

    return (
        <Container>
            <Row>
                <Col>
                    <h3>Neue Anlage</h3>
                    <p className="text-muted">Hier können Sie neue Anlangen hinzufügen</p>
                </Col>
            </Row>

            <Row className="mt-3 justify-content-center">
                <Col xl="10">
                    <Card style={{ borderRadius: 15, minHeight: 200, borderBottom: "6px solid #a2c13f" }} className="shadow-lg">
                        <CardBody>
                            <Steper step={step} data={stepIndicator} hideOn="done" />
                            {
                                step === "choice" ?
                                    <QrOrManuel data={data} setData={setData} formError={formError} setFormError={setFormError} /> :
                                step === "address" ?
                                    <AddressMask data={data} setData={setData} formError={formError} setFormError={setFormError} setPlaces={setPlaces} /> :
                                step === "anlageData" ?
                                    <AnlageDataMask data={data} setData={setData} formError={formError} setFormError={setFormError} /> :
                                step === "register" ?
                                    <RegisterMask data={data} setData={setData} formError={formError} setFormError={setFormError} /> :

                                step === "scannQr" ?
                                    <ScanQrMask data={data} setData={setData} setStep={setStep} /> :

                                step === "summary" ?
                                    <SummaryMask data={data} setStep={setStep} /> : 
                                step === "done" ?
                                    <DoneMask message={"Vielen Dank! Wir haben die Daten zur Anlage erhalten und werden Sie in Kürze bearbeiten."} /> :
                                step === "error" ?
                                    <ErrorMask error={apiError} />
                                : null
                            }
                            <Row className="mt-5" hidden={step === "done" || step === "error"}>
                                <Col xs="12" className="text-end">
                                    <Button
                                        style={{marginRight: 10}}
                                        variant="warning"
                                        hidden={step === "choice"}
                                        onClick={() => backHandler()}
                                    >Zurück</Button>
                                    <Button
                                        disabled={isLoading}
                                        variant="energo"
                                        onClick={!isLoading ? nextHandler : null}
                                    >
                                        {isLoading?
                                            <Spinner animation="border" /> :
                                            step === "summary" ? "Absenden" :
                                            "Weiter"
                                        }
                                    </Button>
                                </Col>
                            </Row>
                            <Row className="mt-5 text-center" hidden={step !== "done"}>
                                <Col>
                                    <a onClick={e => startOver(e)} href="/neue/anlage" className="btn btn-energo me-2">Neue Anlage hinzufügen</a>
                                    <a href="/dashboard/anlagen" className="btn btn-energo">Zum meinen Anlagen</a>
                                </Col>
                            </Row>
                            <Row className="mt-5 text-end" hidden={step !== "error"}>
                                <Col>
                                    <Button variant="warning" className="me-2" onClick={() => setStep("summary")}>Zurück</Button>
                                    <Button 
                                        variant="energo" 
                                        onClick={() => sendData()}
                                    >
                                        Nochmal versuchen
                                    </Button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default AnlageAnmeldePage;